import React, { Component } from 'react';
import { connect } from 'react-redux';
import HomeComponent from '../components/Home'
import { withRouter } from 'react-router-dom';
import { setSettings, getImagesFromApi } from '../actions';

class Home extends Component {

    componentWillMount = () => {
        let path = this.props.location.search.toLowerCase()
        if (path.indexOf('true') > 0)
            this.props.setSettings(true)
        if(!this.props.images)
            this.props.getImagesFromApi()   
    }

    render() {
        return (
            <HomeComponent history={this.props.history} />
        );
    }
}

const mapStateProps = (state) => {
    return {
        images: state.ImagesReducer.images
    }
}

export default withRouter(connect(mapStateProps, { setSettings, getImagesFromApi })(Home));
